import { AuthService } from "../../Services/AuthService";

export const getToken=()=>{
    return AuthService.getToken();
}

export const getUserIdFromLoggedInUser=()=>{
    return AuthService.getUserId();
}